
import { Modal } from '@livecontrol/scheduler/components';
import React from 'react';
import type { ReactElement } from 'react';
import { ConfirmProvider } from './components';
import { ApolloProvider, EventsSocketProvider } from './store';
import { Provider as ThemeProvider } from './theme';

import PromptProvider = Modal.Prompt.Provider;

export const Providers = ({ children, ...rest }: Providers.Props): ReactElement => (
  <ApolloProvider >
    {/* Inside Apollo: the socket evicts deleted events from its cache. */}
    <EventsSocketProvider>
      <ThemeProvider defaultTheme='base' {...rest}>
        <PromptProvider {...rest}>
          <ConfirmProvider>
            {children}
          </ConfirmProvider>
        </PromptProvider>
      </ThemeProvider>
    </EventsSocketProvider>
  </ApolloProvider>);


// eslint-disable-next-line @typescript-eslint/no-redeclare
export namespace Providers {
  export type Props = React.PropsWithChildren<PromptProvider.Props & ThemeProvider.Props>;
}
